import { render, staticRenderFns } from "./PeerGroupMemberList.vue?vue&type=template&id=24d3f88f&"
import script from "./PeerGroupMemberList.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupMemberList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports